import React, { useEffect,useState } from "react";
import "./EmploymentVerification.css";
import EmploymentHistory from "./EmploymentHistory";
import AddNewEmploymentDetailBlock from "./AddNewEmploymentDetailBlock";
import EmploymentGap from "./EmploymentGap";
import { useDispatch, useSelector } from "react-redux";
import { fetchUandetails, saveUanEmployment, fetchEmploymentGap, saveEmploymentGapReason} from "../../Actions/uanActions";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { validateNumeric } from "../../Helper/common";

const RadioYesComponent = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [uanNo, setUanNo] = useState("");
  const [showEmploymentDetails, setShowEmploymentDetails] = useState(false);
  const [showEmploymentGap, setShowEmploymentGap] = useState(false);
  const [buttonText, setButtonText] = useState("Fetch Employment");
  const [isCompleted,setIsCompleted] = useState(false);
  const [reasons,setReasons] = useState({})
  const [errors,setErrors] = useState({});
  const [isInitial,setIsInitial] = useState(true);
  const [isDisabled,setIsDisabled] = useState(false);
  const gapstoreData = useSelector((state) => state.fetchGap);
  const { fetchGapData } = gapstoreData;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  const handleFetchEmployment = () => {
    // You can perform an API call or any other logic here to fetch employment details
    // For demonstration, let's assume an employment gap of 2 years and 8 months
    if(!props?.checkCompleted && !props?.checkCompleted == true && props?.flow!="No"){
      if(uanNo == ''){
        setErrors({uanNo: 'This field is required'});
        return;
      }
      if(uanNo.length != 12 ){
        setErrors({uanNo: 'Please enter valid UAN Number'});
        return;
      }
    }
    const formData = props?.formData
    console.log(formData)
    // if(props?.flow != 'No'){
      dispatch(fetchUandetails(formData?.candidate_id,formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id, uanNo));
      setShowEmploymentDetails(true);
      // setButtonText("Verify");
    // }
  };

  const handleFetchEmp = (val) => {
    const formData = props?.formData;
    let uanNum = uanNo != '' ? uanNo : val;
    dispatch(fetchUandetails(formData?.candidate_id,formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id, uanNo));
    setShowEmploymentDetails(true);
  }

  const handleFetchEmploymentGap = () => {
    // You can perform an API call or any other logic here to fetch employment details
    // For demonstration, let's assume an employment gap of 2 years and 8 months
    const formData = props?.formData
    console.log(formData)
    let record={}
    record.initial_case_id = formData?.candidates?.initial_case_id;
    dispatch(fetchEmploymentGap(record, callbackRedirect))
    
    setShowEmploymentGap(true);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [showAddEmployment, setShowAddEmployment] = useState(false);
  const storeData = useSelector((state) => state.fetchUan);
  const { fetchUanData, loading } = storeData;

  useEffect(() => {
    if(props.flow=="No"){
      const formData = props?.formData
    console.log(formData)
    dispatch(fetchUandetails(formData?.candidate_id,formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id));
    setShowEmploymentDetails(true);
    setShowAddEmployment(true);
    // handleAddEmployment(1);
  }
    
  }, []);

  useEffect(() => {
    if(props?.uanNumber && props?.uanNumber != '' && !props?.manualChange){
      setUanNo(props?.uanNumber);
      handleFetchEmp(props?.uanNumber);
    }
  },[props?.uanNumber]);

  useEffect(() => {
    if(props?.checkCompleted && props?.checkCompleted == true){
      handleFetchEmployment();
      setIsCompleted(true);
    }
  },[props?.checkCompleted])

  useEffect(() => {
    if(props?.gapObject){
      if(props?.gapObject?.total_gap)
      {delete props?.gapObject?.total_gap; }
        // console.log(props?.gapObject);
        let object={}
        Object.entries(props?.gapObject).map(([i, obj]) => {
          console.log(obj.gap_reason,i)
          object[i]=obj.gap_reason;
        })
        setReasons(object)

    }
  },[props?.gapObject])

  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }
    }
    if(typeof fetchUanData !== "undefined" && fetchUanData !== null){
      let count=0
      for (let i = 0; i < fetchUanData?.data?.length; i++) {
        if(fetchUanData?.data[i]?.status==1){
          count+=1;
        }
        
      } 
      if(count==fetchUanData?.data?.length){
        handleFetchEmploymentGap()
      }
      else{
        setShowEmploymentGap(false)
      }
      // if(props.flow=="No" && isInitial){
      //   // setIsInitial(false);
      //   handleAddEmployment(1, fetchUanData); 
      // }
    }
  }, [fetchUanData]);
  console.log(fetchUanData)

  // useEffect(() => {
  //   if(typeof fetchUanData !== "undefined" && fetchUanData !== null){
  //   if(props.flow=="No" && isInitial && fetchUanData?.data && fetchUanData?.data?.length > 0){
  //     // setIsInitial(false);
  //     handleAddEmployment(1, fetchUanData); 
  //   }
  //   }
  // },[fetchUanData])

  const handleAddEmployment = (val, data) => {
    setIsInitial(false);
    // Handle logic for adding employment
    console.log(props?.formData?.emp_uan_count_config)
    let checkValidation = props?.formData?.emp_uan_count_config;
    // if(checkValidation && checkValidation.flag && data?.data && data?.data?.length > 0){
    // if(checkValidation && checkValidation.flag){
    //   let maxCount = checkValidation.count_config.emp_count;
    //   let totalEmpLength = fetchUanData?.data?.length || 0;
    //   let uanEmp = 0;
    //   console.log(fetchUanData?.data);
    //   fetchUanData?.data?.map((item) => {
    //     if(item?.uan_number && item?.uan_number != ''){
    //       uanEmp=uanEmp+1;
    //     }
    //   })
    //   if(maxCount > totalEmpLength - uanEmp){
    //     setShowAddEmployment(true);
    //   }else{
    //     if(val != 1){
    //       toast.dismiss();
    //       toast.error("Maximum number of employments added. ", {
    //         position: "top-right",
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       });
    //     }
    //   }
    // }else{
      setShowAddEmployment(true);
    // }
  };
  const handleCloseEmployment = () => {
    // Handle logic for adding employment
    setShowAddEmployment(false);
  };

  const handleBackClick = () => {
    // Add logic for back button click if needed
  };

  const handleReasonCallback = (reason, index) => {
    let obj={...reasons}
    obj[index]=reason
   setReasons(obj)
  };

  const handleContinueClick = () => {
  if(!showEmploymentGap || isDisabled){
    toast.dismiss();
      toast.error("Please accept all employments", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    return;  
  }
    setIsDisabled(true);
    let gaps = []
    let error = false;
    fetchGapData?.data?.gaps?.map((gap,index)=>{
      if(reasons[index] &&reasons[index]!==""){
        let obj={};
        obj.gap_label=gap?.gap_label
        obj.gap_range=gap?.gap_range
        obj.gap_reason=reasons[index]
        obj.gap_tenure_from=gap?.gap_tenure_from
        obj.gap_tenure_to=gap?.gap_tenure_to
        gaps.push(obj);
      }
      else{

        error=true;
      setIsDisabled(false);
      }
    })
    if(error==true){
      toast.dismiss();
      toast.error("Please Fill all gap reasons.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (error==false)
    {console.log(gaps);
    let payload={}
    payload.initial_case_id = props?.formData?.candidates?.initial_case_id;
    payload.case_check_id = props?.formData?.checksDetails[0]?.case_check_id;
    payload.gap_data = gaps;
    console.log(payload)
    dispatch(saveEmploymentGapReason(payload,saveCallback));}

  
  };

  const saveCallback=()=>{
      // Add logic for continue button click if needed
    let record={}
    record.case_check_id = props?.formData?.checksDetails[0]?.case_check_id;
    let resp = props?.selectedOption != 'Other' ? props?.selectedOption : `${props?.selectedOption}-${props?.reason}`

    let obj = {};
   if(props?.flow == 'No'){
    obj = {
      group: "employment_via_uan",
      "493": 'No',
      "494": resp,
      "employmentAdded": 1
     };
    }else{
      obj = {
        group: "employment_via_uan",
        "493": 'Yes',
        "151": uanNo,
        "employmentAdded": 1
       };
    }

    record.check_data = { [props?.formData?.checksDetails[0]?.case_check_id]: obj };

    console.log(record)
    setTimeout(() => {
      setIsDisabled(false);
    }, 400);
    dispatch(saveUanEmployment(record, callbackRedirect))
  }

  const callbackRedirect=(data)=>{
    setTimeout(() => {
      setIsDisabled(false);
    }, 400);

    if(data?.empUanCallManual==0)
    {
    if (data?.reference_number) {
      const referenceNumber = data?.reference_number;
      const groupID = data?.group?.group_id;
      if (groupID && groupID === "profile_preview") {
        navigate(`/case-initiation/profile-preview/${referenceNumber}`);
      } else {
        navigate(`/case-initiation/check-detail/${referenceNumber}/${groupID}`);
      }
    }
  }}

  const handleChange = (e) => {
    let val = e.target.value;
    if(val == '' || validateNumeric(val)){
      setUanNo(val);
      setErrors({uanNo : ''});
    }
  }

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="mt-4 row p-2">
        <p className="col-12 p-0">{props?.flow != "No" ? 'Please fill required details.' : ''}</p>
        <div className="col p-0">
          {props?.flow!="No" &&<><label htmlFor="uanNo" className="form-label">
            UAN No.<sup className="text-danger">{''}*</sup>
          </label>
          <div className=" col-12 row" style={{ gap: "8px", }}>
            <input
              type="text"
              id="uanNo"
              className="form-control col-lg-4 col-md-7 col-sm-12"
              style={{ width: "100%" }}
              placeholder="Enter UAN No."
              value={uanNo}
              // onChange={(e) => setUanNo(e.target.value)}
              onChange={(e) => handleChange(e)}
              disabled={isCompleted}
            />

            <button
              className="btn btn-primary mb-2"
              style={{
                padding: "6px 20px",
                height: "auto",
              }}
              onClick={handleFetchEmployment}
              disabled={isCompleted}
            >
              {buttonText}
            </button>
            </div>
           <p className="text-danger">{errors.uanNo}</p>                        
          </>}

          {(showEmploymentDetails || props?.flow=="No") && (
            <div className="mt-3">
              <div className="emp-history-text">Employment History</div>
              <div className="m-1">
              <EmploymentHistory history={fetchUanData?.data} callBackFunction={handleFetchEmployment} formData={props?.formData}/>
                {(showAddEmployment && props?.flow=="Yes")&&
                <AddNewEmploymentDetailBlock 
                setShowAddEmployment={setShowAddEmployment} 
                handleCloseEmployment={handleCloseEmployment}
                formData={props?.formData}/>}
                
                {(showAddEmployment && props?.flow=="No")&&
                <AddNewEmploymentDetailBlock 
                setShowAddEmployment={setShowAddEmployment} 
                handleCloseEmployment={handleCloseEmployment}
                formData={props?.formData}
                flow='No'
                />}

              </div>
              <button className="btn btnAddEmp" onClick={handleAddEmployment}>
                + Add Employment
              </button>
              {showEmploymentGap&&<EmploymentGap handleReasonCallback={handleReasonCallback} gapObject={props?.gapObject} reasons={reasons}/>}

              <div className="row mt-2 w-100">
                <div className="col-lg-4 col-md-8 com-sm-12 d-flex justify-content-between align-items-center my-4">
                  {/* <div
                    className="btn btn-lg btn-outline-secondary"
                    onClick={handleBackClick}
                  >
                    Back
                  </div> */}
                  <button
                  className="btn btn-lg btn-primary cursor-pointer"
                  onClick={handleContinueClick}
                  // disabled={!showEmploymentGap || isDisabled}
                >Continue
            </button>
            {props?.showProfilePreview == 1 && (
                  // <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                  // </div>
                )}
                {/* <div className="col-auto d-flex justify-content-between mt-4">
                  <small className="text-muted">
                    Please complete all the mandatory fields before final
                    submission
                  </small>
                </div> */}
                  {/* <div
                    className="btn btn-lg btn-primary"
                    onClick={handleContinueClick}
                  >
                    Continue
                  </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RadioYesComponent;
